import { Pipe, PipeTransform } from '@angular/core';
import { getLocale } from '@lx/shared/i18n';
import { getDateFromString, getOrdinal } from '@lx/shared/utils';

/**
 * Pipe to format a date as an ordinal date string.
 * Example: "1st January 2026", "2nd February 2026", etc.
 */
@Pipe({
  standalone: true,
  name: 'lxOrdinalDate',
})
export class OrdinalDatePipe implements PipeTransform {
  private readonly locale = getLocale();

  transform(value: Date | string): string {
    if (!value) {
      return '';
    }

    let date: Date;
    if (typeof value === 'string') {
      try {
        date = getDateFromString(value);
      } catch (e) {
        return '';
      }
    } else {
      date = value;
    }

    if (isNaN(date.getTime())) {
      return '';
    }

    const day = date.getDate();
    const suffix = getOrdinal(day);
    const month = date.toLocaleString(this.locale, { month: 'long' });
    const year = date.getFullYear();

    return `${day}${suffix} ${month} ${year}`;
  }
}
